<template>
    <div class="tree-line">
        <!-- Vertikální čára - horní polovina (vždy) -->
        <div class="tree-line__vertical-top"></div>
        <!-- Vertikální čára - dolní polovina (skryta pro poslední prvek přes CSS) -->
        <div class="tree-line__vertical-bottom"></div>
        <!-- Horizontální čára -->
        <div class="tree-line__horizontal"></div>
    </div>
</template>
